import React from 'react';
import logo from '../assets/logo.png';
import ModernHeader from './modern/ModernHeader';

// Board-specific bits only; the design is shared (src/components/modern, 2026-10-02 refresh).
export default function Header() {
  return <ModernHeader logo={<img src={logo} className="h-8 w-8" alt="" />} />;
}
